import { Drawer } from "@mui/material";
import { Ban, Check, Minus, RefreshCw, X } from "lucide-react";
import Badge from "./badge";
import { dataHora } from "./tabela-fiscal";
import { verificarNumero, vizinhosDe } from "../_mock/numeros";
import { MODELOS, SITUACOES_NUMERO, TONS } from "../status";

const VERIFICACOES = [
	{ chave: "tentativa", rotulo: "Existe tentativa de emissão?" },
	{ chave: "documento", rotulo: "Existe documento?" },
	{ chave: "xml", rotulo: "Existe XML?" },
	{ chave: "protocolo", rotulo: "Existe protocolo?" },
	{ chave: "inutilizado", rotulo: "Está inutilizado?" },
	{ chave: "precisaInutilizar", rotulo: "Precisa ser inutilizado?", alerta: true },
	{ chave: "venda", rotulo: "Existe venda relacionada?" },
];

function Resposta({ sim, alerta }) {
	const cor = !sim ? "text-gray-400" : alerta ? "text-red-600" : "text-emerald-600";
	const Icone = sim ? Check : Minus;

	return (
		<span className={`inline-flex items-center gap-1 font-medium ${cor}`}>
			<Icone size={14} />
			{sim ? "Sim" : "Não"}
		</span>
	);
}

function Vizinho({ rotulo, registro }) {
	return (
		<div className="border border-gray-200 rounded-md px-3 py-2">
			<div className="text-xs text-gray-500">{rotulo}</div>
			{registro ? (
				<>
					<div className="flex items-center gap-2 mt-1">
						<span className="font-semibold text-gray-800">{registro.numero}</span>
						<Badge {...SITUACOES_NUMERO[registro.status]} />
					</div>
					<div className="text-xs text-gray-500 mt-0.5">{dataHora(registro.data_emissao ?? registro.data_cadastro)}</div>
				</>
			) : (
				<div className="text-sm text-gray-400 mt-1">Nenhum no sistema</div>
			)}
		</div>
	);
}

function Conteudo({ linha, onFechar, onAcao }) {
	const verificacao = verificarNumero(linha);
	const { anterior, seguinte } = vizinhosDe(linha);
	const situacao = SITUACOES_NUMERO[linha.status];
	const retorno = linha.cstat && `${linha.cstat} · ${linha.motivo}`;

	return (
		<div className="flex flex-col h-full">
			<div className="shrink-0 border-b px-5 py-4 flex items-start justify-between gap-3">
				<div>
					<div className="flex items-center gap-2 flex-wrap">
						<h2 className="text-lg font-semibold text-gray-800 mb-0">
							{MODELOS[linha.modelo]} nº {linha.numero}
						</h2>
						<Badge {...situacao} />
					</div>
					<p className="text-sm text-gray-500 mb-0">Série {linha.serie} · Análise do número</p>
				</div>
				<button type="button" onClick={onFechar} className="p-1 rounded hover:bg-gray-100 text-gray-500">
					<X size={20} />
				</button>
			</div>

			<div className="flex-1 overflow-y-auto px-5 py-4 flex flex-col gap-4">
				{retorno && <div className={`rounded-md border px-3 py-2 text-sm ${TONS[situacao.tom]}`}>{retorno}</div>}

				<div className="grid grid-cols-2 gap-3">
					<Vizinho rotulo="Número anterior" registro={anterior} />
					<Vizinho rotulo="Número seguinte" registro={seguinte} />
				</div>

				<ul className="border border-gray-200 rounded-md divide-y divide-gray-200 mb-0 pl-0">
					{VERIFICACOES.map(({ chave, rotulo, alerta }) => (
						<li key={chave} className="list-none flex items-center justify-between px-3 py-2 text-sm">
							<span className="text-gray-700">{rotulo}</span>
							<Resposta sim={verificacao[chave]} alerta={alerta} />
						</li>
					))}
				</ul>

				<p className="text-xs text-gray-400 mb-0">Verificação simulada. A consulta real será feita pelo backend.</p>
			</div>

			{verificacao.precisaInutilizar && (
				<div className="shrink-0 border-t px-5 py-3 flex justify-end gap-2">
					<button
						type="button"
						onClick={() => onAcao("consultar", linha)}
						className="btn btn-sm btn-outline-primary inline-flex items-center gap-1.5"
					>
						<RefreshCw size={14} />
						Consultar na SEFAZ
					</button>
					<button
						type="button"
						onClick={() => onAcao("inutilizar", linha)}
						className="btn btn-sm btn-outline-danger inline-flex items-center gap-1.5"
					>
						<Ban size={14} />
						Inutilizar
					</button>
				</div>
			)}
		</div>
	);
}

export default function PainelNumero({ linha, onFechar, onAcao }) {
	return (
		<Drawer
			anchor="right"
			open={Boolean(linha)}
			onClose={onFechar}
			disableEnforceFocus
			PaperProps={{ sx: { width: { xs: "100%", sm: 460 } } }}
		>
			{linha && <Conteudo linha={linha} onFechar={onFechar} onAcao={onAcao} />}
		</Drawer>
	);
}
